module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('top-nav-section', {
    attrs: {
      "menus": _vm.menus,
      "back-link": _vm.backLink,
      "display": _vm.showTopNav
    }
  }), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('video-player', {
    ref: "videoPlayer",
    staticClass: "background",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "custom-control": false
    }
  }), _vm._v(" "), _c('app-dash-gallery', {
    ref: "gallery",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }), _vm._v(" "), (false) ? _c('app-dash-swiper', {
    ref: "gallery",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a24819c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheMainContainer.vue
// module id = 223
// module chunks = 1